import { Badge } from '@design-system';
import { X } from 'lucide-react';

import type { ActiveShopFilterChip } from '@/features/shop-insurance/hooks/use-shop-insurance-active-filters';

interface AdjustedQuotesBannerProps {
  filters: ActiveShopFilterChip[];
}

export function AdjustedQuotesBanner({ filters }: AdjustedQuotesBannerProps) {
  return (
    <div
      className="flex items-start gap-2 rounded-md border p-2.5"
      data-testid="shop-insurance-active-filters"
    >
      <p className="text-foreground ml-0.5 shrink-0 py-0.5 text-xs font-semibold uppercase tracking-wide">
        Active Filters:
      </p>
      <div className="flex flex-wrap gap-2">
        {filters.map(filter => (
          <Badge key={filter.key}>
            {filter.label}
            {filter.onRemove && (
              <button
                onClick={filter.onRemove}
                className="inline-flex"
                aria-label={`Remove ${filter.label} filter`}
                type="button"
              >
                <X className="size-3" />
              </button>
            )}
          </Badge>
        ))}
      </div>
    </div>
  );
}
